/**
 * 전화번호 문자열을 하이픈이 포함된 형식으로 변환합니다.
 * @param phoneNumber 01033334444 혹은 010-3333-4444 형태의 전화번호 문자열
 * @returns 010-3333-4444 형태의 포맷된 전화번호 문자열, 유효하지 않은 입력은 원래 값 반환
 */
export const formatPhoneNumber = (phoneNumber: string): string => {
    if (!phoneNumber) return phoneNumber;

    // 이미 하이픈이 포함된 경우, 모든 하이픈 제거 후 다시 포맷팅
    const digits = phoneNumber.replace(/-/g, '');

    // 유효한 전화번호 길이 확인 (대부분의 한국 전화번호는 10-11자리)
    if (!/^\d{10,11}$/.test(digits)) {
        return phoneNumber; // 유효하지 않은 형식이면 원래 값 반환
    }

    // 11자리 휴대폰 번호 (010-XXXX-XXXX)
    if (digits.length === 11) {
        return `${digits.substring(0, 3)}-${digits.substring(3, 7)}-${digits.substring(7)}`;
    }

    // 10자리 전화번호 (02-XXXX-XXXX 또는 지역번호)
    if (digits.length === 10) {
        // 서울 지역번호(02)인 경우
        if (digits.startsWith('02')) {
            return `${digits.substring(0, 2)}-${digits.substring(2, 6)}-${digits.substring(6)}`;
        }
        // 그 외 지역번호나 휴대폰 번호
        return `${digits.substring(0, 3)}-${digits.substring(3, 6)}-${digits.substring(6)}`;
    }

    return phoneNumber; // 예상치 못한 길이의 경우 원래 값 반환
};
